export default __webpack_public_path__ + "static/science_guy-d1740c6b3b8f35fe307ebb461b94f6d3.jpg";